import React__default from 'react';
import { Typography, Icon } from '@sravni/react-design-system';
import { ArrowRight } from '@sravni/react-icons';
import { useAuthLoginLink } from '@sravni/react-utils';

const AuthorizationLink = ({ className, onClick }) => {
    const link = useAuthLoginLink();
    return (React__default.createElement(Typography.Text, { size: 14, strong: true, className: className },
        React__default.createElement(Typography.Link, { ...link, onClick: onClick }, "\u0412\u043E\u0439\u0434\u0438\u0442\u0435"),
        ", \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u044D\u0442\u0438 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F ",
        React__default.createElement(Icon, { size: 20, icon: React__default.createElement(ArrowRight, null), style: { verticalAlign: 'middle' } })));
};

export { AuthorizationLink };
//# sourceMappingURL=AuthorizationLink.js.map
